import { Card } from '../ui/card';
import { Lightbulb } from 'lucide-react';

export const TriviaCard = ({ trivia }) => (
  <Card className="p-6 sm:p-8 bg-gradient-to-br from-purple-50 to-pink-50 border-purple-200">
    <div className="flex items-center gap-3 mb-6">
      <Lightbulb className="w-6 h-6 sm:w-8 sm:h-8 text-purple-600" />
      <h2 className="text-xl sm:text-2xl font-serif font-bold">Today's Media Literacy Insight</h2>
    </div>

    <div className="bg-white rounded-lg p-5 sm:p-6">
      <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4">
        {trivia.title}
      </h3>
      <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
        {trivia.content}
      </p>
    </div>

    <div className="mt-4 text-xs sm:text-sm text-purple-600 text-center">
      New insight every day - Building media literacy one story at a time
    </div>
  </Card>
);
